import { translate } from "@atoms/atom-client/i18n";
/* defines which type of roller is used for a case */
export enum ROLLER_TYPE {
  NONE = 0,
  CORNER_INBOARD = 1,
  CORNER_OUTBOARD = 2,
  EDGE = 3,
  CREEPER = 4,
}

/**
 * Roller type labels in the UI language (read on access). The name is kept for
 * compatibility; the labels are no longer German-only.
 */
export const ROLLER_TYPE_LABEL_DE: Record<ROLLER_TYPE, string> = {
  get [ROLLER_TYPE.NONE]() {
    return translate("app.manufacturer.rollerTypes.none", "Keine");
  },
  get [ROLLER_TYPE.CORNER_INBOARD]() {
    return translate(
      "app.manufacturer.rollerTypes.cornerInboard",
      "Einbau-Eckrolle",
    );
  },
  get [ROLLER_TYPE.CORNER_OUTBOARD]() {
    return translate(
      "app.manufacturer.rollerTypes.cornerOutboard",
      "Aufbau-Eckrolle",
    );
  },
  get [ROLLER_TYPE.EDGE]() {
    return translate("app.manufacturer.rollerTypes.edge", "Kantenrolle");
  },
  get [ROLLER_TYPE.CREEPER]() {
    return translate("app.manufacturer.rollerTypes.creeper", "Bodenrolle");
  },
};
